module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture22-90b372f46faac20d9fcf35cfc96dc6ec.jpg";